import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { TextareaModule } from 'primeng/textarea';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { TextBoxCPanelComponent } from './customizationPanel';

export interface TextBoxCustomization {
  placeHolder: string;
  defaultValue: string;
  showIfRule: string;
  autocompleteRule: boolean;
  required: boolean;
  weight: number;
}

@Component({
  selector: 'lib-textbox-edit',
  imports: [
    MatButtonModule,
    TextBoxCPanelComponent,
    TextareaModule,
    FormsModule,
  ],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-textbox-custom-panel
        (closed)="widgetService.settingVisibility.set(false)"
      />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="flex h-full flex-col gap-2">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center gap-2">
            {{ widgetService.computedDescription() }}
          </div>
        }
        <div class="flex w-full flex-row gap-2">
          <textarea
            id="data"
            pTextarea
            [placeholder]="widget.customization.placeHolder"
            [ngModel]="widget.customization.defaultValue"
            class="w-full bg-white"
            [disabled]="true"
          ></textarea>
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class TextBoxComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<TextBoxCustomization>);
}
